"use client";

import Link from "next/link";

import { Button } from "@workspace/ui/components/button";
import { cn } from "@workspace/ui/lib/utils";
import { EventNames, sendEvent } from "@/lib/utils/analytics";

type GetInitoKitCtaProps = {
  className?: string;
  size?: "default" | "lg";
  eventProperties?: Record<string, unknown>;
  id?: string;
};

export function GetInitoKitCta({
  className,
  size = "default",
  eventProperties,
  id,
}: GetInitoKitCtaProps) {
  return (
    <Button
      id={id}
      data-testid={id}
      variant="default"
      size={size}
      asChild
      className={cn(
        size === "lg"
          ? "w-full max-w-[400px] lg:w-[220px]"
          : "w-full max-w-[400px] xl:w-fit",
        className,
      )}
    >
      <Link
        href="/buy-now"
        onClick={() =>
          sendEvent(EventNames.GET_INITO_KIT_CLICKED, eventProperties)
        }
      >
        Get the Inito Fertility Monitor
      </Link>
    </Button>
  );
}
